module.exports = __webpack_public_path__ + "img/description4.28776756.jpg";